import axios from "axios";
import { Constants } from '../utils/Constants';

export function get(id) {
	return axios.get(`${Constants.baseUrl}/perfil`);
}

export function update(id, form) {
	return axios.post(`${Constants.baseUrl}/perfil`, form);
}